import { createElement, createContext, useContext } from 'react';
import { ColorPickerProviderProps } from './types';
import { ColorPickerDataProvider, getColorPickerDataProvider } from './__internal__';

const ColorPickerContext = createContext<ColorPickerDataProvider | undefined>(undefined);

export const useColorPickerService = () => {
  return useContext(ColorPickerContext);
};

export const ColorPickerProvider = (props: ColorPickerProviderProps) => {
  return (
    <ColorPickerContext.Provider value={props.value ?? getColorPickerDataProvider()}>
      {props.children}
    </ColorPickerContext.Provider>
  );
};
